import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useServiceQuery } from "@/hooks/use-services";
import { useServiceStore } from "@/stores/service-store";

export function ServiceSwitchPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { setSelectedService } = useServiceStore();
  const { data: service, isLoading, isError } = useServiceQuery(id || "");

  useEffect(() => {
    if (service) {
      setSelectedService(service);
      navigate("/", { replace: true });
    }
  }, [service, setSelectedService, navigate]);

  useEffect(() => {
    if (isError) {
      navigate("/", { replace: true });
    }
  }, [isError, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <p className="text-muted-foreground">Switching service...</p>
      </div>
    );
  }

  return null;
}
